module.exports = __webpack_public_path__ + "img/asana.56ae5812.svg";